import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { ChevronDown } from 'lucide-react';
export function FAQ() {
  const faqs = [{
    q: 'Can you support high-volume hiring projects?',
    a: 'Yes, we have the capacity and strategic processes to handle both single specialized roles and high-volume team builds. We scale our sourcing efforts to meet your timeline while maintaining our strict quality standards.'
  }, {
    q: 'What level of English do candidates have?',
    a: 'We only present candidates with advanced to native-level English proficiency (C1/C2). We rigorously test both written and verbal communication skills during our vetting process to ensure seamless integration with your North American team.'
  }, {
    q: 'What countries do you recruit from?',
    a: 'We recruit across the entirety of Latin America, with strong networks in countries like Mexico, Colombia, Argentina, Brazil, Costa Rica, and Chile. This allows us to find the absolute best talent regardless of borders, while keeping time zones aligned.'
  }, {
    q: "What happens if the hire doesn't work out?",
    a: "We offer a comprehensive 90-day replacement guarantee. If a candidate doesn't meet your expectations or leaves within the first three months, we will conduct a new search and replace them at no additional cost."
  }, {
    q: 'What industries do you specialize in?',
    a: 'We partner with a wide range of industries including SaaS, E-commerce, Financial Services, Healthcare Tech, and Professional Services. Our focus is on the functional roles (Finance, Ops, Sales, Tech) that drive these businesses forward.'
  }, {
    q: 'Do you offer direct-hire and staffing solutions?',
    a: 'We primarily focus on direct-hire placements, finding dedicated, long-term team members who integrate directly into your company culture and operations. We can advise on the best employment or contractor models for LATAM.'
  }, {
    q: 'How does pricing work?',
    a: "We operate on a transparent, success-based or retained model depending on the complexity of the search. Our fees are highly competitive and represent a fraction of the cost savings you'll achieve by hiring in LATAM. We discuss specific pricing during our initial consultation."
  }];
  const [openIndex, setOpenIndex] = useState<number | null>(0);
  return <section id="faq" className="py-24 bg-white" data-id="element-21">
      <div className="max-w-3xl mx-auto px-6" data-id="element-22">
        <div className="text-center mb-16" data-id="element-23">
          <motion.h2 initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} className="text-4xl font-bold mb-6 text-navy" data-id="element-24">
            Frequently Asked Questions
          </motion.h2>
        </div>

        <div className="space-y-4" data-id="element-25">
          {faqs.map((faq, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 10
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: index * 0.1
        }} className="border border-slate-200 rounded-2xl overflow-hidden" data-id="element-26">
              <button onClick={() => setOpenIndex(openIndex === index ? null : index)} className="w-full flex items-center justify-between p-6 text-left bg-white hover:bg-slate-50 transition-colors" data-id="element-27">
                <span className="font-bold text-navy text-lg pr-8" data-id="element-28">
                  {faq.q}
                </span>
                <ChevronDown className={`w-5 h-5 text-slate-400 shrink-0 transition-transform duration-300 ${openIndex === index ? 'rotate-180' : ''}`} data-id="element-29" />
              </button>
              <AnimatePresence data-id="element-30">
                {openIndex === index && <motion.div initial={{
              height: 0,
              opacity: 0
            }} animate={{
              height: 'auto',
              opacity: 1
            }} exit={{
              height: 0,
              opacity: 0
            }} transition={{
              duration: 0.3
            }} data-id="element-31">
                    <div className="p-6 pt-0 text-slate-600 leading-relaxed border-t border-slate-100" data-id="element-32">
                      {faq.a}
                    </div>
                  </motion.div>}
              </AnimatePresence>
            </motion.div>)}
        </div>
      </div>
    </section>;
}